import { useContext } from 'react'

import { OkeFrameContext } from '../contexts/OkeFrameContext'

const ScreenOrientations = [
  { label: "portrait", value: "PORTRAIT" },
  { label: "landscape", value: "LANDSCAPE" },
  { label: "portraitFlipped", value: "PORTRAIT_FLIPPED" },
  { label: "landscapeFlipped", value: "LANDSCAPE_FLIPPED" }
]

export default function useOkeFrame() {
  let {
    sendMessageToWebView,
    frameType,
    frameVersion,
    systemInfo,
    brand,
    model
  } = useContext(OkeFrameContext)

  const getSerialPorts = async (data) => {
    let res = await sendMessageToWebView({ action: 'getSerialPorts', data })
    return res?.data
  }

  const getPrinters = async (data) => {
    let res = await sendMessageToWebView({ action: 'getPrinters', data })
    return res?.data
  }

  const getPairedBT = async (data) => {
    let res = await sendMessageToWebView({ action: 'getBTDevices', data })
    return res?.data
  }

  const getUsbDevices = async (data) => {
    let res = await sendMessageToWebView({ action: 'escposGetUsbDevices', data })
    return res?.data
  }

  const setScreenOrientation = async (orientation) => {
    let res = await sendMessageToWebView({ action: 'setScreenOrientation', data: { orientation } })
    return res?.data
  }

  const getScreenInfo = async (data) => {
    let res = await sendMessageToWebView({ action: 'getScreenInfo', data })
    return res?.data
  }

  const logoff = async (data) => {
    let res = await sendMessageToWebView({ action: 'logoff', data })
    return res?.data
  }

  const fetchkePost = async (data) => {
    let res = await sendMessageToWebView({ action: 'fetchkePost', data })
    return res?.data
  }

  const fetchkeGet = async (data) => {
    let res = await sendMessageToWebView({ action: 'fetchkeGet', data })
    return res?.data
  }

  return {
    sendMessageToWebView, 
    frameType,
    frameVersion,
    systemInfo,
    getPrinters, 
    getSerialPorts, 
    getPairedBT,
    getUsbDevices,
    setScreenOrientation, 
    getScreenInfo, 
    ScreenOrientations,
    logoff,
    brand,
    model,
    fetchkeGet,
    fetchkePost
  }
}